import { Button, SvgExternalLink } from '@loomhq/lens';
import React from 'react';

import * as analytics from 'utilities/analytics';
import * as intercom from 'utilities/intercom';

import AddCollaboratorCardImg from 'img/workspace-onboarding/edit-together.png';

import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { ADD_COLLABORATOR_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

const SUPPORT_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360004011237-How-to-invite-teammates-to-collaborate-on-your-video';

const PRODUCT_TOUR_ID = 115050;
const PRODUCT_TOUR_LINK = `https://www.loom.com/shared-videos?product_tour_id=${PRODUCT_TOUR_ID}`;

const AddCollaboratorCard = ({ cardConfig }) => {
  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={() => {
        analytics.track(
          DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED,
          {
            type: 'secondary',
            card: ADD_COLLABORATOR_CARD_KEY,
          },
          () => {
            window.open(SUPPORT_ARTICLE_LINK);
          }
        );
      }}
    >
      Learn how
    </DashboardOnboardingSecondaryAction>
  );

  const tourIsOnSamePage = PRODUCT_TOUR_LINK.includes(window.location.pathname);

  const buttonAction = () => {
    analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
      type: 'primary',
      card: ADD_COLLABORATOR_CARD_KEY,
    });

    if (!tourIsOnSamePage) {
      window.location.href = PRODUCT_TOUR_LINK;
    } else {
      intercom.startTour(PRODUCT_TOUR_ID);
    }
  };

  const primaryAction = <Button onClick={buttonAction}>Show me how</Button>;

  const centerpiece = <img src={AddCollaboratorCardImg} />;

  return (
    <DashboardOnboardingCard
      cardKey={ADD_COLLABORATOR_CARD_KEY}
      cardConfig={cardConfig}
      heading="Edit and manage your videos together"
      description="Invite other Workspace members to edit a video in your personal library."
      centerpiece={centerpiece}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage="You invited a Workspace member to edit a video in your personal library. Up top for teamwork 🙌"
      showClose={false}
    />
  );
};

export default AddCollaboratorCard;
